import { useEffect, useState } from "react";
import { adminApi, eur, fmtDate, PLAN } from "@/lib/adminApi";

const ACTION_LABEL = {
  activate: "Aktiviran", deactivate: "Deaktiviran", block: "Blokiran", unblock: "Odblokiran",
  grant_trial: "Dodeljena proba", refund: "Refundirano", payment: "Plaćeno",
};

const derive = (d, payments) => {
  const ev = [{ ts: d.created_at, text: "Uređaj kreiran (prvo pokretanje aplikacije)" }];
  if (d.trial_end && d.trial_end * 1000 < Date.now() && !d.activated) ev.push({ ts: d.trial_end, text: "Probni period istekao" });
  if (d.activated_at) ev.push({ ts: d.activated_at, text: `Aktiviran • ${PLAN[d.plan] || d.plan || ""}`, by: d.activated_by === "admin" ? "Admin (ručno)" : d.activated_by === "stripe" ? "Stripe uplata" : d.activated_by });
  payments.forEach((t) => {
    if (t.payment_status === "paid") ev.push({ ts: t.paid_at, text: `Plaćeno ${eur(t.amount_eur)} • ${t.package_id === "lifetime" ? "Doživotno" : "Godišnje"}`, by: t.email || "Stripe" });
    else ev.push({ ts: t.created_at, text: `Započeto plaćanje ${eur(t.amount_eur)} (nije završeno)`, by: t.source });
    if (t.refunded) ev.push({ ts: null, text: `Refundirano ${eur(t.amount_eur)} — uređaj blokiran`, by: "Admin / Stripe" });
  });
  if (d.blocked && !payments.some((t) => t.refunded)) ev.push({ ts: null, text: "Uređaj je trenutno blokiran", by: "Admin" });
  if (d.last_seen) ev.push({ ts: d.last_seen, text: "Poslednja aktivnost u aplikaciji" });
  return ev.sort((a, b) => (b.ts ?? Infinity) - (a.ts ?? Infinity));
};

export const DeviceHistory = ({ d }) => {
  const [events, setEvents] = useState(null);
  useEffect(() => {
    adminApi.get(`/admin/devices/${d.device_id}/history`)
      .then((r) => setEvents(r.data.map((e) => ({ ts: e.ts, text: `${ACTION_LABEL[e.action] || e.action}${e.details ? ` • ${e.details}` : ""}`, by: e.by }))))
      .catch(() => adminApi.get(`/admin/devices/${d.device_id}/payments`)
        .then((r) => setEvents(derive(d, r.data)))
        .catch(() => setEvents(derive(d, []))));
  }, [d]);

  if (!events) return <p className="text-xs text-muted2">Učitavanje istorije…</p>;
  return (
    <ol className="relative ml-2 flex flex-col gap-3 border-l border-lineStrong pl-4" data-testid={`history-${d.device_key}`}>
      {events.map((e, i) => (
        <li key={i} className="relative text-xs" data-testid="history-item">
          <span className="absolute -left-[21px] top-1 h-2.5 w-2.5 rounded-full bg-brand" />
          <p className="font-semibold text-white">{e.text}</p>
          <p className="text-muted2">{e.ts ? fmtDate(e.ts) : "datum nije zabeležen"}{e.by ? ` • ${e.by}` : ""}</p>
        </li>
      ))}
    </ol>
  );
};
